import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { TableColumn } from '@models/tableColumn';
import { plainToClass } from 'class-transformer';
import { Subscription, interval } from 'rxjs';
import '@angular/localize/init';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { TableOptions } from '@models/tableOptions';
import { DomSanitizer } from '@angular/platform-browser';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { ChargingStation } from '@models/charging-station';
import { ModelDto } from '@dto/modelDto';
import { Profile } from '@models/profile'
import { ManufacturerDto } from '@dto/manufacturerDto';
import { Model } from '@models/model';
import { ModelsService } from '../../../services/entity/models.services';
import { ManufacturersService } from '../../../services/entity/manufacturer.services';
import { Manufacturer } from '../../../models/manufacturer';
@Component({
  selector: 'app-chargingstationprofiles-table',
  templateUrl: './chargingstationprofiles.component.html',
  styleUrls: ['./chargingstationprofiles.component.scss']
})

export class ChargingStationProfilesComponent extends AbstractEntitiesTableComponent implements OnInit, OnDestroy {

  public className = 'ChargingStationProfilesComponent';
  public chargingstation: ChargingStationDto;
  public activeComponentClassName: string = 'ChargingStationProfilesComponent';


  @Output() stationCount = new EventEmitter<number>();

  public entities: ModelDto[];
  public isOperatorView: boolean;
  public user: boolean = false;
  public customer: boolean = false;
  public operator: boolean = false;
  public showAll: boolean = false;
  public display: string = 'none';
  public profile: Profile;


  @Output() newEntityEvent = new EventEmitter<ModelDto>();

  private sortParam: number;
  private isAnyCheckBoxSelected: boolean;
  public manufacturer: ManufacturerDto[];

  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:Hersteller`, property: 'manufacturer.name' },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:Modell`, property: 'name' },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:ERK`, property: 'profile.isErk', options: {'isBoolean':true} },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:Ladepunkte`, property: 'profile.numberOfConnectors' },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:1.6`, property: 'profile.isOcpp16', options: {'isBoolean':true} },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:2.0`, property: 'profile.isOcpp20', options: {'isBoolean':true} },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:2.01`, property: 'profile.isOcpp201', options: {'isBoolean':true} },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:Aktualisierbar`, property: 'profile.isUpdatable', options: {'isBoolean':true} },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:4G`, property: 'profile.isMobile', options: {'isBoolean':true} },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:BiDi`, property: 'profile.isBidi', options: {'isBoolean':true} },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:AC`, property: 'profile.isAc', options: {'isBoolean':true} },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:DC`, property: 'profile.isDc', options: {'isBoolean':true} },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:Plug'n'charge`, property: 'profile.isPnc', options: {'isBoolean':true} },
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:Integration erfolgreich`, property: 'integrationDate'},
  ];


  public tableOptions: TableOptions = { hideActions: true, rowRouterLink: 'edit/{id}' };
    model: Model;

  constructor(
    public chargingstationservice: ChargingStationsService,
    public manufacturerservice: ManufacturersService,
    public sanitizer: DomSanitizer,
    private dialog: NgbModal,
    injector: Injector
  ) {
    super(chargingstationservice, injector);
  }


  ngOnInit(): void {
    this.getRoles();
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    this.showAll = this.activatedRoute.snapshot.data['showAll'];

    this.activatedRoute.queryParams.subscribe(params => {
      this.sortParam = params.sort;
    });
    super.ngOnInit();
  }

  async initializeEntities() {
    if (this.isOperatorView) {
      if (this.showAll) {
        this.chargingstationservice.getModels().subscribe(result => {
          this.entities = plainToClass(ModelDto, result);
          this.stationCount.emit(this.entities.length)
          super.setupTable();
          this.tableFunctions.sortColumn = 'manufacturer.name';
          this.tableFunctions.sortDirection = 'asc';
        }, error => { });
        this.tableOptions = { hideActions: true, rowRouterLink: 'edit/{id}' };
      }
    }
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.customer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.operator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.user = true;
    }
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  matches(entity: ModelDto, term: string) {
    return ModelsService.matches(entity, term)
  }

}
